<!-- <app-dynamic-form [inputRowsObservable]="dynamicInputRows"></app-dynamic-form> -->


<div class="row">
    <div class="col-lg-12" style="margin-bottom: 20px;" *ngIf="!user">
        <div class="top_column_btn">
            <div (click)="columnChange('12')"><img src="../../../../assets/images/single.png" title="single column">
            </div>
            <div (click)="columnChange('4')"><img src="../../../../assets/images/three.png" title="three column"></div>
            <div (click)="columnChange('3')"><img src="../../../../assets/images/four.png" title="four column"></div>
        </div>
    </div>

    <div class="clearfix"></div>
    <div class="col-lg-3 float-left">
        <div class="sidebar-listing" *ngIf="!displayPalette">

            <div class="top_heading">
                <div class="col-md-10">Placeholders</div>
            </div>

            <div class="headingMessage mt-2">
                <span><img class="mr-1" src="/assets/images/admin_reports_icons/info-grey.png">Click on the list to drop
                    fields on right section</span>
                <input type="text" placeholder="Search Placeholders" [(ngModel)]="placeHolderFilter"
                    class="form-control">
            </div>

            <div class="subHeading">Pre-defined Section</div>
            <ul style="height:250px; overflow: auto;" class="mt-2 mb-2">


                <li *ngFor="let standard of placeHolderStandardArray | vdBuilderFilter:{keyword:placeHolderFilter}; let i = index"
                    draggable="true" (dragend)="onDragEnd($event, standard)">
                    <div class="placeHolderContainer">
                        <div>{{standard.label}}</div>
                        <div class="tickSign">&#10004;</div>
                    </div>
                </li>
            </ul>
            <hr class="separator">
            <div class="subHeading">Custom Section</div>
            <ul style="height:250px; overflow: auto; margin-top:20px" class="mt-2 mb-2">


                <li *ngFor="let custom of placeHolderCustomArray | vdBuilderFilter:{keyword:placeHolderFilter}; let i = index"
                    cdkDrag draggable="true" (cdkDragEnded)="onDragEnd($event, custom)" class="example-boundary">
                    <div class="placeHolderContainer example-box">
                        <div>{{custom.label}}</div>
                    </div>
                </li>
            </ul>
        </div>

        <div *ngIf="displayPalette">

            <div class="sidebar-listing paletteSidebar">

                <div class="top_heading">
                    <div class="col-md-12 back" (click)="backSetting()"> <span>&#10094;</span>Settings:
                        {{palette.label}} </div>
                </div>

                <ul class="nav nav-tabs" style="overflow:hidden; height: auto;">
                    <li class="nav-item">
                        <a class="nav-link custom-nav-link" [ngClass]="{'activeNav': showTabs == 'general'}"
                            (click)="tabs('general')">General</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link custom-nav-link" [ngClass]="{'activeNav': showTabs == 'optional'}"
                            (click)="tabs('optional')">Optional</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link custom-nav-link" [ngClass]="{'activeNav': showTabs == 'advanced'}"
                            (click)="tabs('advanced')">Advanced</a>
                    </li>
                </ul>

                <div *ngIf="palette.isConfigurable">
                    <div class="tab-content"
                        *ngIf="(palette.layoutCode !== 'CustomQuestionsGroupComponent' && palette.layoutCode !== 'CustomRadioButtonComponent') || palette.layoutCode !== 'CustomQuestionsGroupComponent' && palette.layoutCode !== 'CustomFormRadioButtonComponent'">
                        <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">

                            <div class="p-fluid p-formgrid p-grid pt-2"
                                *ngIf="palette.layoutCode !== 'VdSwitchGroupComponent' && palette.layoutCode !== 'VdDividerComponent' && palette.layoutCode !== 'VdLabelComponent'">
                                <div class="p-col-11 marginBtmLeft"
                                    *ngIf="palette.layoutCode !== 'VdTextAreaComponent'">
                                    <label class="label-cls mb-1">Label Name</label>
                                    <input type="text" [placeholder]="palette.label" #label name="label"
                                        [(ngModel)]="palette.label" />
                                    <div class="indicatorRef">Label of the field</div>
                                </div>
                                <div class="p-col-11 marginBtmLeft"
                                    *ngIf="palette.layoutCode === 'VdTextAreaComponent'">
                                    <label class="label-cls mb-1">Label Name</label>
                                    <input type="text" [placeholder]="palette.properties.textArealabel" #textArealabel
                                        name="textArealabel" [(ngModel)]="palette.properties.textArealabel" />
                                    <div class="indicatorRef">Label of the field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Sub Label</label>
                                    <input type="text" class="form-control" [placeholder]="palette.subText" #sublabel
                                        name="sublabel" [(ngModel)]="palette.subText" />
                                    <div class="indicatorRef">Add small description below the input field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Align to</label>
                                    <div class="clearfix"></div>
                                    <div class="vd-radio-container">
                                        <input type="radio" class="radio" name="align" value="top" id="top"
                                            (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                                        <label for="top" class="label-cls mb-1">Top</label>

                                        <input type="radio" class="radio" name="align" value="left" id="left"
                                            (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                                        <label for="left" class="label-cls mb-1">Left</label>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="indicatorRef">Select how the label is placed</div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="p-col-11 marginBtmLeft">
                                    <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Prevent submission, if the field is empty</div>
                                </div>

                            </div>
                            <div class="p-fluid p-formgrid p-grid pt-2"
                                *ngIf="palette.layoutCode === 'VdSwitchGroupComponent'">
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Label Name</label>
                                    <input type="text" [placeholder]="palette.groupElementProperty.questionLabel"
                                        #questionLabel name="questionLabel"
                                        [(ngModel)]="palette.groupElementProperty.questionLabel" />
                                    <div class="indicatorRef">Label of the field</div>
                                </div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Text Area Label</label>
                                    <input type="text" class="form-control"
                                        [placeholder]="palette.groupElementProperty.textAreaLabel" #textAreaLabel
                                        name="textAreaLabel" [(ngModel)]="palette.groupElementProperty.textAreaLabel" />
                                    <div class="indicatorRef">Label of the Text Area</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Sub Label</label>
                                    <input type="text" class="form-control" [placeholder]="palette.subText" #sublabel
                                        name="sublabel" [(ngModel)]="palette.subText" />
                                    <div class="indicatorRef">Add small description below the input field</div>
                                </div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Label Width</label>
                                    <input type="text" #labelStyleWidth name="labelStyleWidth"
                                        [(ngModel)]="palette.groupElementProperty.labelStyle.width" />
                                </div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Text Area Width</label>
                                    <input type="text" #textAreaWidth name="textAreaWidth"
                                        [(ngModel)]="palette.groupElementProperty.textAreaStyle.width" />
                                </div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Show Text Area when switch is </label>
                                    <select type="text" class="form-control" #whenTextAreaShown name="whenTextAreaShown"
                                        [(ngModel)]="palette.groupElementProperty.whenTextAreaShown">
                                        <option value="on">On</option>
                                        <option value="off">Off</option>
                                        <option value="both">Both</option>
                                    </select>

                                </div>

                                <!-- <div class="p-col-11 marginBtmLeft">
                                <label class="label-cls mb-1">Label Align to</label>
                                <div class="clearfix"></div>
                                <div class="vd-radio-container">
                                    <input type="radio" class="radio" name="align" value="top" id="top" (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                                    <label for="top" class="label-cls mb-1">Top</label>
    
                                    <input type="radio" class="radio" name="align" value="left" id="left" (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                                    <label for="left" class="label-cls mb-1">Left</label>
                                </div>
                                <div class="clearfix"></div>
                                <div class="indicatorRef">Select how the label is placed</div>
                            </div> -->
                                <div class="clearfix"></div>
                                <div class="p-col-11 marginBtmLeft">
                                    <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Prevent submission, if the field is empty</div>
                                </div>

                            </div>
                            <div class="p-fluid p-formgrid p-grid pt-2"
                                *ngIf="palette.layoutCode === 'VdDividerComponent'">

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1"> Width</label>
                                    <input type="text" #dividerWidth name="dividerWidth"
                                        [(ngModel)]="palette.style.width" />
                                </div>
                                <div class="clearfix"></div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Color</label>
                                    <input type="color" id="favcolor" name="favcolor"
                                        [value]="palette.style.borderColor"
                                        [(ngModel)]="palette.style.borderColor"><br><br>
                                    <!-- <input type="text" #dividerWidth name="dividerWidth" [(ngModel)]="palette.style.width" /> -->
                                </div>
                                <div class="clearfix"></div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Divider Type</label>
                                    <select type="text" class="form-control" #dividerType name="dividerType"
                                        [(ngModel)]="palette.style.borderStyle">
                                        <option>Select</option>
                                        <option value="dashed">Dashed</option>
                                        <option value="solid">Solid</option>
                                        <option value="dotted">Dotted</option>
                                    </select>
                                    <div class="indicatorRef">Type of divider line</div>
                                </div>


                            </div>
                            <div class="p-fluid p-formgrid p-grid pt-2"
                                *ngIf="palette.layoutCode === 'VdLabelComponent'">

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Title</label>
                                    <input type="text" [placeholder]="palette.properties.title" #title name="title"
                                        [(ngModel)]="palette.properties.title" />
                                    <div class="indicatorRef">Enter the text/ content </div>
                                </div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Color</label>
                                    <input type="color" id="favcolor" name="favcolor" [value]="palette.style.color"
                                        [(ngModel)]="palette.style.color"><br><br>
                                    <!-- <input type="text" #dividerWidth name="dividerWidth" [(ngModel)]="palette.style.width" /> -->
                                </div>
                                <div class="clearfix"></div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Font Weight</label>
                                    <select type="text" class="form-control" #fontWeight name="fontWeight"
                                        [(ngModel)]="palette.style.fontWeight">
                                        <option>Select</option>
                                        <option value="bold">Bold</option>
                                        <option value="normal">Normal</option>
                                        <option value="bolder">Bolder</option>
                                        <option value="lighter">Lighter</option>
                                    </select>
                                    <div class="indicatorRef">Font Weight</div>
                                </div>


                            </div>

                        </div>
                        <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">


                            <div class="p-fluid p-formgrid p-grid pt-2">

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Width</label>
                                    <div class="clearfix"></div>
                                    <div class="vd-radio-container">
                                        <input type="radio" class="radio" name="align" value="top" id="top"
                                            (change)="palette.align = 'top'" [attr.checked]="palette.align == 'top'" />
                                        <label for="top" class="label-cls mb-1">Fixed</label>

                                        <input type="radio" class="radio" name="align" value="left" id="left"
                                            (change)="palette.align = 'left'"
                                            [attr.checked]="palette.align == 'left'" />
                                        <label for="left" class="label-cls mb-1">Auto</label>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="indicatorRef">The width of this field will change accordingly to your
                                        form's width</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Width of the field</label>
                                    <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Field Validation</label>
                                    <select type="text" class="form-control" #validation name="validation">
                                        <option>Select</option>
                                    </select>
                                    <div class="indicatorRef">Check if the entry matches the selected format</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <div class="indicatorRef">Character Limit</div>
                                    <p-inputSwitch id="requiredValidation" formControlName="requiredValidation"
                                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                                </div>

                                <div class="p-col-12 marginBtmLeft">
                                    <div class="p-col-6 float-left">
                                        <label class="label-cls mb-1">Min. character</label>
                                        <input type="text" class="form-control" #minLength name="minLength"
                                            [(ngModel)]="palette.minLength" />
                                    </div>

                                    <div class="p-col-6 float-right">
                                        <label class="label-cls mb-1">Max. character</label>
                                        <input type="text" class="form-control" #maxLength name="maxLength"
                                            [(ngModel)]="palette.maxLength" />
                                    </div>
                                    <div class="indicatorRef">Limit the number of character allowed for this</div>

                                </div>

                            </div>

                        </div>
                        <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">

                            <div class="p-fluid p-formgrid p-grid pt-2">

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Placeholder</label>
                                    <input type="text" #placeholder name="placeholder"
                                        [(ngModel)]="palette.placeholder" />
                                    <div class="indicatorRef">Add an example hint inside the field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Hover Text</label>
                                    <input type="text" #hoverText name="hoverTest" [(ngModel)]="palette.hoverText" />
                                    <div class="indicatorRef">Show a description of this field when hovered</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Default Value</label>
                                    <input type="text" #defaultValue name="defaultValue"
                                        [(ngModel)]="palette.defaultValue" />
                                    <div class="indicatorRef">Pre populate a value for this field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <div class="indicatorRef">Read Only</div>
                                    <p-inputSwitch id="readOnly" [(ngModel)]="palette.readonly"
                                        (onChange)="readonly($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Prevent entry to thsi field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <div class="indicatorRef">Hide Field</div>
                                    <p-inputSwitch id="hideField" formControlName="hideField"
                                        (onChange)="hideField($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Hide Field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Unique Name</label>
                                    <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <select type="text" class="form-control" #validation name="validation">
                                        <option>Rule for the field</option>
                                    </select>
                                </div>

                            </div>

                        </div>


                    </div>


                    <div class="tab-content" *ngIf="palette.layoutCode == 'CustomQuestionsGroupComponent'">
                        <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">

                            <div class="p-fluid p-formgrid p-grid pt-2">
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Label Name</label>
                                    <input type="text" [placeholder]="palette.label" #label name="label"
                                        [(ngModel)]="palette.label" />
                                    <div class="indicatorRef">Label of the field</div>
                                </div>
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Unique Name</label>
                                    <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Width</label>
                                    <input type="text" #labelStyleWidth name="labelStyleWidth"
                                        [(ngModel)]="palette.style.width" />
                                </div>
                            </div>


                        </div>
                        <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">

                        </div>
                        <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">


                        </div>


                    </div>

                    <div class="tab-content" *ngIf="(palette.layoutCode === 'CustomRadioButtonComponent') || (palette.layoutCode === 'CustomFormRadioButtonComponent')">
                        <div class="tab-pane container active" id="general" *ngIf="showTabs == 'general'">

                            <div class="p-fluid p-formgrid p-grid pt-2">
                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Label Name</label>
                                    <input type="text" [placeholder]="palette.label" #label name="label"
                                        [(ngModel)]="palette.label" />

                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Align to</label>
                                    <div class="clearfix"></div>
                                    <div class="vd-radio-container">
                                        <input type="radio" class="radio" name="align" value="top" id="top"
                                            (change)="palette.align = 'top'" [checked]="palette.align == 'top'" />
                                        <label for="top" class="label-cls mb-1">Top</label>

                                        <input type="radio" class="radio" name="align" value="left" id="left"
                                            (change)="palette.align = 'left'" [checked]="palette.align == 'left'" />
                                        <label for="left" class="label-cls mb-1">Left</label>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="p-col-11 marginBtmLeft">
                                    <p-inputSwitch id="requiredValidation" [(ngModel)]="palette.mandatory"
                                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Mandatory</div>
                                </div>

                            </div>

                        </div>

                        <div class="tab-pane container active" id="optional" *ngIf="showTabs == 'optional'">


                            <div class="p-fluid p-formgrid p-grid pt-2">

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Width</label>
                                    <div class="clearfix"></div>
                                    <div class="vd-radio-container">
                                        <input type="radio" class="radio" name="align" value="top" id="top"
                                            (change)="palette.align = 'top'" [attr.checked]="palette.align == 'top'" />
                                        <label for="top" class="label-cls mb-1">Fixed</label>

                                        <input type="radio" class="radio" name="align" value="left" id="left"
                                            (change)="palette.align = 'left'"
                                            [attr.checked]="palette.align == 'left'" />
                                        <label for="left" class="label-cls mb-1">Auto</label>
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="indicatorRef">The width of this field will change accordingly to your
                                        form's width</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Width of the field</label>
                                    <input type="text" #width name="width" [(ngModel)]="palette.style.width" />
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Field Validation</label>
                                    <select type="text" class="form-control" #validation name="validation">
                                        <option>Select</option>
                                    </select>
                                    <div class="indicatorRef">Check if the entry matches the selected format</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <div class="indicatorRef">Character Limit</div>
                                    <p-inputSwitch id="requiredValidation" formControlName="requiredValidation"
                                        (onChange)="requiredValidation($event)"></p-inputSwitch>
                                </div>

                                <div class="p-col-12 marginBtmLeft">
                                    <div class="p-col-6 float-left">
                                        <label class="label-cls mb-1">Min. character</label>
                                        <input type="text" class="form-control" #minLength name="minLength"
                                            [(ngModel)]="palette.minLength" />
                                    </div>

                                    <div class="p-col-6 float-right">
                                        <label class="label-cls mb-1">Max. character</label>
                                        <input type="text" class="form-control" #maxLength name="maxLength"
                                            [(ngModel)]="palette.maxLength" />
                                    </div>
                                    <div class="indicatorRef">Limit the number of character allowed for this</div>

                                </div>

                            </div>

                        </div>
                        <div class="tab-pane container active" id="advanced" *ngIf="showTabs == 'advanced'">

                            <div class="p-fluid p-formgrid p-grid pt-2">

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Placeholder</label>
                                    <input type="text" #placeholder name="placeholder"
                                        [(ngModel)]="palette.placeholder" />
                                    <div class="indicatorRef">Add an example hint inside the field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Hover Text</label>
                                    <input type="text" #hoverText name="hoverTest" [(ngModel)]="palette.hoverText" />
                                    <div class="indicatorRef">Show a description of this field when hovered</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Default Value</label>
                                    <input type="text" #defaultValue name="defaultValue"
                                        [(ngModel)]="palette.defaultValue" />
                                    <div class="indicatorRef">Pre populate a value for this field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <div class="indicatorRef">Read Only</div>
                                    <p-inputSwitch id="readOnly" [(ngModel)]="palette.readonly"
                                        (onChange)="readonly($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Prevent entry to thsi field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <div class="indicatorRef">Hide Field</div>
                                    <p-inputSwitch id="hideField" formControlName="hideField"
                                        (onChange)="hideField($event)"></p-inputSwitch>
                                    <div class="indicatorRef">Hide Field</div>
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <label class="label-cls mb-1">Unique Name</label>
                                    <input type="text" #uniqueName name="uniqueName" [(ngModel)]="palette.name" />
                                </div>

                                <div class="p-col-11 marginBtmLeft">
                                    <select type="text" class="form-control" #validation name="validation">
                                        <option>Rule for the field</option>
                                    </select>
                                </div>

                            </div>

                        </div>


                    </div>
                </div>

                <div *ngIf="palette.isConfigurable && palette.controlType == 'STANDARD'" class="px-2">
                    Configuring the element
                    <hr />
                    <div *ngIf="palette.fieldConfiguration && palette.fieldConfiguration.length > 0">
                        <div *ngFor="let item of palette.fieldConfiguration">
                            <div class="row p-0 m-0">
                                <div class="col-9 p-0 m-0"><label>{{item?.label}}</label></div>
                                <div class="col-1 p-0 m-0">
                                    <p-inputSwitch [(ngModel)]="item.showField" class="pl-2"></p-inputSwitch>
                                </div>
                            </div>
                            <div class="row p-0 m-0" *ngIf="item.fieldType === 'inputText'">
                                <div class="row"><label>{{item?.label}}</label></div>
                                <div class="row">
                                   <input type="text"  [(ngModel)]="item.value" />
                                </div>
                            </div>
                            <div class="row p-1" *ngIf="item.fieldName === 'showPrimaryApplicantSection' && item.showField">
                                <label class="label-cls mb-1">Select Relationship code to include</label>
                                <p-multiSelect [style]="{width: '250px'}" optionValue="code" [options]="familyRelTypeArr"
                                [(ngModel)]="item.dependentList" defaultLabel="Select Relationship" optionLabel="name">
                              </p-multiSelect>
                            </div>

                            <div class="row p-1" *ngIf="item.fieldName === 'showApplicantDetailSection' && item.showField">
                               <div class="row">
                                <label class="label-cls mb-1">Enter the label text</label>
                                <input type="text"  [(ngModel)]="item.questionLabelText" />
                              </div>
                              <div class="row p-1">
                                <div class="col-10 p-0 m-0"><label>Show Switch For Enable/Disable</label></div>
                                <div class="col-1 p-0 m-0">
                                    <p-inputSwitch [(ngModel)]="item.enableSwitch" class="pl-2"></p-inputSwitch>
                                </div>
                            </div>
                            <div class="row">
                                <label class="label-cls mb-1">Show Primary Applicant Too</label>
                                <p-checkbox [(ngModel)]="item.showPrimaryApplicantToo" [binary]="true" class="pl-2"></p-checkbox>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="saveButton" (click)="saveSetting()" *ngIf="isEditVisa">
                Save Field
            </div>

            <div class="deleteButton" (click)="deleteField()" *ngIf="isEditVisa">
                Delete Field
            </div>


        </div>
    </div>


    <div [ngClass]="{'col-lg-12': user == true,'col-lg-9 float-right': user == false}">

        <div class="rightside-panel" id="dataPanel" cdkDropList (cdkDropListDropped)="drop($event)">
            <div class="top_heading">
                <div class="col-md-10">Drag & drop required fields & sections from list</div>
                <div class="col-md-2 text-right"><span>&#10094;</span>Preview</div>
            </div>

            <div class="npTemplate" *ngIf="htmlRenderObj?.length == 0">Hey, You have not set any template, You can drag
                from list and drop here...</div>

            <div class="clearfix"></div>

            <form #taskForm="ngForm" [formGroup]="addForm">

                <div *ngFor="let _data of htmlRenderObj; let i = index;"
                    [ngClass]="{'noBorder': user == true,'customContainer relative': user == false}" cdkDrag>

                    <div class="vd-heading-container">

                        <div class="actionItems">
                            <mat-icon class="crossIcon" (click)="openPalette(i)" *ngIf="_data.isConfigurable">edit
                            </mat-icon>
                            <mat-icon class="crossIcon" *ngIf="isEditVisa" (click)="removeBox(i)">delete</mat-icon>

                        </div>
                    </div>

                    <div style="clear:both"></div>

                    <app-component-loader *ngIf="_data.controlType == 'STANDARD'" [rendercomponent]="_data.layoutCode"
                        [fieldConfiguration]="_data.isConfigurable ? _data.fieldConfiguration:null">
                    </app-component-loader>

                    <app-component-loader class="inlineblock" *ngIf="_data.controlType == 'CUSTOM'"
                        [rendercomponent]="_data.layoutCode" [sublabel]="_data.subText" [validation]="_data.mandatory"
                        [readonly]="_data.readonly" [minLength]="_data.minLength" [maxLength]="_data.maxLength"
                        [placeHolders]="_data.placeholder" [groupElementProperty]="_data.groupElementProperty"
                        [typeOfButton]="_data.layoutCode ==='StepStatusUpdateComponentLibraryComponent' && _data.label === 'Edit' ? 'EDIT' : 'MARK_COMPLETE'"
                        [group]="addForm"
                        [groupName]="_data.layoutCode ==='VdSwitchGroupComponent'  ? 'switchGroup' : null"
                        [inputParams]="_data"></app-component-loader>

                </div>
                <br><br>
            </form>
        </div>
    </div>

    <div class="clearfix"></div>
    <div class="col-12 mt-4">
        <p-divider type="dashed"></p-divider>
        <div class="buttonContainer my-2">
            <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="hadleCancel()">CANCEL</button></div>
            <div> <button type="submit" class="btn vdCreateBtn mr-3" (click)="onSubmit('event')"
                    [disabled]="htmlRenderObj?.length == 0">NEXT</button></div>

        </div>
    </div>

    <div class="clearfix"></div>
    <p-confirmDialog header="Delete"></p-confirmDialog>